import * as PDFObject from 'pdfobject'
import { closest } from "@/javascript/components/tools/closest"
import { slideUp } from "@/javascript/components/animations/slide"
import Loader from "@/javascript/components/loader"
import { Toggler } from "@/javascript/components/toggling"
import $ from "jquery"

const getSelectize = (content, id) => {
  const select = content.querySelector(`#${id}`)
  if(!select) {
    return
  }

  return select.selectize
}

Loader.functional((content, resolve) => {
  const employerNameSelectize = getSelectize(content, 'work_history_employer_name')
  if(employerNameSelectize) {
    employerNameSelectize.on('change', (newValue) => {
      if(newValue) {
        setIndustry(content, newValue)
      }
    })
  }

  const pdfContainer = content.querySelector('#pdf_container')
  if(pdfContainer) {
    if(PDFObject.supportsPDFs && !pdfContainer.dataset.cvEmbedded) {
      PDFObject.embed(pdfContainer.dataset.cvUrl, "#pdf_container")
      pdfContainer.dataset.cvEmbedded = true
    }
    if(!pdfContainer.dataset.cvEmbedded) {
      content.querySelector('.cv .download-link').classList.add('show')
    }
  }

  resolve()
})

$(document).on('ajax:success', '.certification .delete', function() {
  slideUp(closest(this, '.certification'))
})

$(document).on('ajax:success', '.work-history .delete', function() {
  slideUp(closest(this, '.work-history'))
})

const setIndustry = (content, companyName) => {
  if(companyName.length) {
    $.getJSON(`/profiles/api/find_industry.json?company_name=${companyName}`, (data) => {
      getSelectize(content, 'work_history_industry_id').setValue(data.industry_id)
    })
      .fail(() => {
        getSelectize(content, 'work_history_industry_id').setValue('')
      })
  } else {
    getSelectize(content, 'work_history_industry_id').setValue('')
  }
}
